import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export var authorizationScopes = [{
  id: 'summary',
  name: 'Datos de contacto',
  included: []
}, {
  id: 'profile',
  name: 'Perfil',
  included: ['summary']
}];
export var getAuthorizationScopeById = function getAuthorizationScopeById(id) {
  var scope = authorizationScopes.find(function (item) {
    return item.id === id;
  });
  return scope ? scope : null;
};